import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import moment from "moment";
import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import { faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import commonStyles from "../../../lib/common/common.module.css";
import { update, listFAQs, removeFAQ, getAllCMSCountry, deleteCountryBlog } from "../api";
import { BlogSchema } from "../validations";
import styles from "../styles/cms.module.css";
import { CMS_TYPE, LOCAL_CONSTANTS } from "../../../lib/constants";
import { CMSTypes } from "../../../interfaces";
import { CONSTANTS } from "../../../lib/constants/messages";
import { ActionButton, DropDownMenu, Pagination, Popup } from "../../../ui";
import CreateUpdateFAQPopup from "../../../ui/Popup/createUpdateFAQ";
import { IMAGES } from "../../../assets/images";
import CreateUpdateBlog from "../../../ui/Popup/createUpdateBlog";
import { useParams } from "react-router-dom";

interface Props {
  cms: CMSTypes.SpecificCMS;
  cmsType: number;
  resetCMS: () => void;
};

const Blogs = ({ cms, cmsType, resetCMS }: Props) => {
  const [faqPopup, setFaqPopup] = useState<{ show: boolean, faq: CMSTypes.Faq | null }>({ show: false, faq: null });
  const [faqLoading, setFAQLoading] = useState<boolean>(true);
  const [faqs, setFaqs] = useState<{ list: any, count: number }>({ list: [], count: 0 });
  const [pagination, setPagination] = useState<{ skip: number, limit: number }>({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [dialog, setDialog] = useState({ show: false, id: "" });
  const { id } = useParams<{ id: string }>();
  const [cmsId, setCMSId] = useState<string>('');
  const [faqIndex, setFaqIndex] = useState<number>(0);
  const [error, setError] = useState<string>("");
  const getFaqs = () => {
    const query = {
      page: (1 + pagination.skip),
      limit: pagination.limit,
      type: CMS_TYPE.BLOGS,
      countryId: id,
    }
    getAllCMSCountry(query).then(res => {
      setFaqs({ list: res.blogPosts, count: res?.count });
      setCMSId(res._id);
      setFAQLoading(false);
      setError(res?.message);
    }).catch(err => {
      setFAQLoading(false);
      setError(err.response.data.message);
    });
  };

  const deleteFAQ = () => {
    toast.promise(
      deleteCountryBlog(cmsId,faqIndex.toString()),
      {
        pending: {
          render() {
            return "Deleting Blog...";
          },
        },
        success: {
          render() {
            getFaqs();

            setDialog({ show: false, id: "" });
            return "Blog deleted successfully";
          },
        },
        error: {
          render({ data }: any) {
            return "Failed to delete Blog";
          },
        },
      });
  };

  const cmsFormik = useFormik({
    initialValues: { content: cms && cms.content },
    onSubmit: (values, { setSubmitting }) => {
      const payload = { content: values.content as string, type: cmsType };

      toast.promise(
        update(payload),
        {
          pending: {
            render() {
              return CONSTANTS.CMS.UPDATING;
            },
          },
          success: {
            render() {
              resetCMS();

              return CONSTANTS.CMS.SUCCESS;
            },
          },
          error: {
            render() {
              setSubmitting(false);

              return CONSTANTS.CMS.FAILED;
            },
          },
        });
    },
    enableReinitialize: true,
    validationSchema: BlogSchema,
  });

  useEffect(() => {
    setFAQLoading(true);
    getFaqs();
  }, [pagination.skip]);

  return (
    <div>
      <form
        onSubmit={cmsFormik.handleSubmit}
      >
        <div className={styles.tabDtahd}>
          <h4>Blogs</h4>
          <div>
            <button type="button" onClick={() => setFaqPopup({ show: true, faq: null })}>
              <img
                width={100}
                height={100}
                src={IMAGES.EditIcon}
                alt="defaultUser"
              />
              Create
            </button>
          </div>
        </div>

        <div
          className={commonStyles.tableData}
        >
          <div className={commonStyles.tableData}>
            <table>
              <thead>
                <tr>
                  {LOCAL_CONSTANTS.blogsCustomersTableHeaders?.map((header: any) => (
                    <th
                      className={`${["title", "author"].includes(header?.value)
                        ? "cursor-pointer"
                        : ""
                        }`}
                      key={header?.value}
                    >
                      {header?.label}

                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {faqLoading && (
                  <tr>
                    <td colSpan={7} align="center" className={styles.loadingText}>
                      {LOCAL_CONSTANTS.loading}
                    </td>
                  </tr>
                )}
                {error && (
                  <tr>
                    <td colSpan={7} align="center" className={styles.loadingText}>
                      {error}
                    </td>
                  </tr>
                )}
                {!faqLoading && faqs?.list?.length === 0 && (
                  <tr>
                    <td colSpan={3} align="center">
                      No Faq Found
                    </td>
                  </tr>
                )}
                {!faqLoading &&
                  faqs?.list?.map((item: any, index: number) => (
                    <tr key={item._id}>
                      <td>

                        {item?.title}
                      </td>
                      <td>
                        {item?.author}
                      </td>
                      <td>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </td>
                      <td>
                        <Dropdown className="ps-0">
                          <div className="cursor-pointer">
                            <Dropdown.Toggle as={ActionButton}></Dropdown.Toggle>
                          </div>
                          <Dropdown.Menu as={DropDownMenu}>
                            <Dropdown.Item onClick={() => {
                              setFaqPopup({ show: true, faq: item });
                              setFaqIndex(index);
                            }}>
                              <FontAwesomeIcon
                                size="xs"
                                className="me-2"
                                icon={faPencilAlt}
                              />
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() =>{ setDialog({ show: true, id: item._id }); setFaqIndex(index)}}>
                              <FontAwesomeIcon
                                size="xs"
                                className="me-2"
                                icon={faTrashAlt}
                              />
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {faqs.count > faqs?.list?.length &&
              <Pagination
                paginationState={pagination}
                setPaginationState={setPagination}
                count={faqs.count}
              />
            }
          </div>
        </div>
      </form>

      {/* <CreateUpdateFAQPopup
        show={faqPopup.show}
        handleClose={() => setFaqPopup({ show: false, faq: null })}
        getFaqs={getFaqs}
        faq={faqPopup.faq}
        typeOfPage={8}
      /> */}
      <CreateUpdateBlog
        show={faqPopup.show}
        handleClose={() => setFaqPopup({ show: false, faq: null })}
        getFaqs={getFaqs}
        faq={faqPopup.faq}
        typeOfPage={CMS_TYPE.BLOGS}
        cmsId={cmsId}
        faqIndex={faqIndex}
      />
      <Popup
        show={dialog.show}
        handleClose={() => setDialog({ show: false, id: "" })}
        heading={LOCAL_CONSTANTS.areYouSure}
        content={"Are you sure you want to delete this Blog?"}
        handleSubmit={deleteFAQ}
        id={dialog.id}
      />
    </div>
  );
};

export default Blogs;